import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

import {useWalletBalance} from '~/api/deimos/wallet'

export function useCheckCurrencyAvailability(options?: {shouldRedirect?: boolean}) {
    const navigate = useNavigate()

    const {isLoading, error} = useWalletBalance()
    const isCurrencyDataAvailable = Boolean(!error)

    useEffect(() => {
        if (!options?.shouldRedirect) {
            return
        }

        if (!isLoading && !isCurrencyDataAvailable) {
            navigate('/wallet', {replace: true})
        }
    }, [navigate, isLoading, isCurrencyDataAvailable, options?.shouldRedirect])

    return {
        isCurrencyDataAvailable,
        isLoading,
    }
}
